const ApplicationName = 'Billing-International';
const billIntPrefix = 'International-';
const Links = Object.freeze({
    billing: billIntPrefix + 'Billing Tile Clicked',
    billingSummary: billIntPrefix + 'Billing Summary Download CSV File',
    downloadCSV: billIntPrefix + 'Download CSV File',
    downloadPDF: billIntPrefix + 'Download PDF File',
    raiseInvoiceEnquiry: billIntPrefix + 'Invoice enquiry',
    raiseCreditEnquiry: billIntPrefix + 'Credit/debit note enquiry',
    raiseEnquiry: billIntPrefix + 'New enquiry',
    bulkDownloadCSV: billIntPrefix + 'Download Bulk CSV File',
    bulkDownloadPDF: billIntPrefix + 'Download Bulk PDF File',
    changeCompany: billIntPrefix + 'Changed Company dropdown value',
    changeAccount: billIntPrefix + 'Changed Account dropdown value'
});

const Components = Object.freeze({
    billingLandingPage: billIntPrefix + 'Billing Landing Page',
    billingDownloadInvoiceListPDF: billIntPrefix + 'Click on row on Download PDF Button on Billing Invoice List Page',
    billingDownloadInvoiceListCSV: billIntPrefix + 'Click on row on Download CSV Button on Billing Invoice List Page',
    billingSummaryInvoiceTab: billIntPrefix + 'Click on Invoices Tab/',
    billingSummaryCreditTab: billIntPrefix + 'Click on Credit/debit note Tab/',
    billingSummaryEnquiryTab: billIntPrefix + 'Click on Enquiry Tab/',
    billingEnquiryPage: billIntPrefix + 'Click on Navigate to Enquiry Page',
    billingAdjustmentsPage: billIntPrefix + 'Click on Navigate to Adjustments Page',
    billingInvoicesPage: billIntPrefix + 'Click on Navigate to Invoices Page',
    billingFaqPage: billIntPrefix + 'Click on Navigate to FAQ Page',

});

const Buttons = Object.freeze({
    ThreeDots: billIntPrefix + 'Click on Three Dots',
    DownloadOption: billIntPrefix + 'Click on Download Option for Bulk',
})
const Page = Object.freeze({
    billingInvoicesPage: billIntPrefix + 'From Billing Invoices Page',
    billingAdjustmentsPage: billIntPrefix + 'From Billing Adjustments Page',
    billingEnquiriesPage: billIntPrefix + 'From Billing Enquires Page',
})

export {
    ApplicationName,
    Components,
    Page,
    Links,
    Buttons,
};
